// We map this way to ensure that each key in lokalise is present in code.
// This allows us to clean up unnecessary codes in the future.
export const mapLanguageCodeToLanguageKey = (languageCode) => {
    const lokaliseKey = {
        sv: 'language_sv',
        da: 'language_da',
        de: 'language_de',
        en: 'language_en',
        fr: 'language_fr',
        nl: 'language_nl'
    }[languageCode.toLowerCase()];
    if (!lokaliseKey)
        throw `Language ${languageCode} has no mapping to lokalise key`;
    return lokaliseKey;
};
